import React, { useRef, useState } from 'react';
import { DataScroller } from 'primereact/datascroller';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ErrorMessage, Formik, Form as FormFormik, Field } from 'formik';
import { api } from '../../services/contratoApi';
import * as yup from 'yup';
import './styles.css';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';

const CardAviso = ({ props }) => {
    const [avisoSelecionado, setAvisoSelecionado] = useState('');
    const [visivel, setVisivel] = useState(false);
    const permisao = decriptObjectOnLocalStorage('PERM');

    //* Funções para carregar o componente Growl
    const mensagemSucesso = useRef(null);
    const mensagemErro = useRef(null);

    const mostrarMensagemSucesso = () => {
        mensagemSucesso.current.show({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Aviso inserido com sucesso!',
            life: 2000,
            closable: false
        });
    };

    const mostrarMensagemErro = () => {
        mensagemErro.current.show({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível inserir o aviso! Tente novamente mais tarde.',
            life: 4000,
            closable: false
        });
    };

    const recarregarPagina = () => {
        window.location.reload();
    };

    const handleSubmit = async avisoEditado => {
        const editarAviso = await api.put(
            `/avisos/${avisoEditado.Id_mess}`,
            avisoEditado
        );

        try {
            if (editarAviso.status === 200) {
                setVisivel(false);
                mostrarMensagemSucesso();
            }
        } catch (err) {
            setVisivel(false);
            mostrarMensagemErro();
        }
    };

    const valoresIniciais = {
        Id_mess: avisoSelecionado.Id_mess,
        Titulo: avisoSelecionado.Titulo,
        Texto: avisoSelecionado.Texto
    };

    const schema = yup.object().shape({
        Titulo: yup
            .string()
            .max(100, 'Assunto precisa ter menos de 100 caracteres.')
            .required('O campo assunto é obrigatório'),
        Texto: yup
            .string()
            .max(100, 'A descrição precisa ter menos de 255 caracteres')
            .required('O campo descrição é obrigatório')
    });
    const renderizarLista = aviso => (
        <>
            <div
                className="p-grid content-wrapper"
                onClick={() => {
                    setAvisoSelecionado(aviso);
                    setVisivel(true);
                }}
                role="dialog"
                data-testid="card-aviso"
            >
                <div className="p-col-6  item">
                    <div className="title">
                        <span>Data</span>
                    </div>
                    <input
                        type="date"
                        name="data"
                        id="data"
                        value={aviso.Data_Criacao.split('T')[0]}
                        disabled
                        mask="99/99/9999"
                    />
                </div>
                <div className="p-col-6 item">
                    <div className="title">
                        <span>Autor</span>
                    </div>
                    <input
                        type="text"
                        name="autor"
                        id="autor"
                        value={aviso['AnalistaComercial.Nome']}
                        disabled
                    />
                </div>
                <div className="p-col-12 item">
                    <div className="title">Assunto</div>
                    <input
                        type="text"
                        name="assunto"
                        id="assunto"
                        value={aviso.Titulo}
                        disabled
                    />
                </div>
                <div className="p-col-12 item">
                    <div className="title">
                        <span>Descrição</span>
                    </div>
                    <textarea disabled value={aviso.Texto}></textarea>
                </div>
            </div>
        </>
    );

    const abrirModal = () => {
        if (avisoSelecionado) {
            return (
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={valoresIniciais}
                    validationSchema={schema}
                >
                    <FormFormik
                        className="p-grid modal-wrapper"
                        data-testid="modal-aviso"
                    >
                        <div className="p-col-6  item-modal">
                            <div className="title">
                                <span>Data</span>
                            </div>
                            <input
                                type="date"
                                name="data"
                                id="data"
                                value={avisoSelecionado.Data_Criacao.split('T')[0]}
                                disabled
                                mask="99/99/9999"
                            />
                        </div>
                        <div className="p-col-6 item-modal">
                            <div className="title">
                                <span>Autor</span>
                            </div>
                            <input
                                type="text"
                                name="autor"
                                id="autor"
                                value={avisoSelecionado['AnalistaComercial.Nome']}
                                disabled
                            />
                        </div>
                        <div className="p-col-12 item-modal">
                            <div className="title">
                                <span>Assunto</span>
                            </div>

                            {permisao === '7' ? (
                                <>
                                    <Field
                                        as="input"
                                        name="Titulo"
                                        id="Titulo"
                                        data-testid="input-assunto"
                                    />
                                    <ErrorMessage
                                        component="span"
                                        name="Titulo"
                                        style={{ color: 'red' }}
                                    />
                                </>
                            ) : (
                                <input
                                    type="text"
                                    name="Titulo"
                                    id="Titulo"
                                    value={avisoSelecionado.Titulo}
                                    disabled
                                />
                            )}
                        </div>
                        <div className="p-col-12 item-modal">
                            <div className="title">
                                <span>Descrição</span>
                            </div>
                            {permisao === '7' ? (
                                <>
                                    <Field
                                        as="textarea"
                                        name="Texto"
                                        id="Texto"
                                        data-testid="input-descricao"
                                    />
                                    <ErrorMessage
                                        component="span"
                                        name="Texto"
                                        id="Texto"
                                        style={{ color: 'red' }}
                                    />
                                </>
                            ) : (
                                <textarea
                                    disabled
                                    value={avisoSelecionado.Texto}
                                ></textarea>
                            )}
                        </div>
                        {permisao === '7' ? (
                            <div className="botoes-modal">
                                <Button
                                    label="Editar Aviso"
                                    icon="pi pi-pencil"
                                    iconPos="right"
                                    type="submit"
                                />
                            </div>
                        ) : (
                            <></>
                        )}
                    </FormFormik>
                </Formik>
            );
        } else {
            return null;
        }
    };

    const itemTemplate = aviso => renderizarLista(aviso);

    return (
        <>
            {props.length === 0 ? (
                <span>Nenhum aviso cadastrado</span>
            ) : (
                <>
                    <DataScroller
                        id={props.Id_mess}
                        value={props}
                        rows={props.length}
                        itemTemplate={itemTemplate}
                        className="lista-avisos"
                    />

                    <Dialog
                        header="Detalhe do Aviso"
                        visible={visivel}
                        modal
                        dismissableMask
                        onHide={() => setVisivel(false)}
                    >
                        {abrirModal()}
                    </Dialog>
                    <Growl
                        ref={mensagemSucesso}
                        onRemove={recarregarPagina}
                        baseZIndex={10000}
                    />
                    <Growl ref={mensagemErro} />
                </>
            )}
        </>
    );
};

export default CardAviso;
